import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextAreaSF from '../../../../widgets/form/InputTextAreaSF'
import InputDateUI from '../../../../widgets/form/InputDateUI'
import InputSelectSF from '../../../../widgets/form/InputSelectSF'

const LoanRemarksCreateModalUI = ({ context, successMsg, errorList, setErrorList, legal,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  remarks, onRemarksChange, remarksError, setRemarksError,
  action, onActionChange, actionError, setActionError, actionList,
  dateISO, onDateISOChange, dateISOError, setDateISOError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Add remarks'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextAreaSF type='text' name='remarks' label='Remarks'
      value={remarks} onChange={onRemarksChange}
      error={remarksError} setError={setRemarksError}
      help='2000 characters max'
    />
    {legal &&
      <InputSelectSF
        type='select' name='action' label='Action'
        value={action} onChange={onActionChange} optionList={actionList.map(item => ({ value: item.key, value: item.value }))}
        error={actionError} setError={setActionError}
      />
    }
    {legal &&
      <InputDateUI type='date' name='dateISO' label='Action Date'
        context={context}
        selectedDateISO={dateISO} onChange={onDateISOChange}
        error={dateISOError} setError={setDateISOError}
      />
    }
  </ModalFormUI>

export default LoanRemarksCreateModalUI
